import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

import PropertySettings, { propertySettingsPropTypes } from './property_settings';
import OnMarketDisclaimer, { onMarketDisclaimerProps } from './property_edit_form/on_market_disclaimer';
import SaleMarketingVisibility from './sale_marketing_visibility';
import LeaseMarketingVisibility from './lease_marketing_visibility';

export class PropertyEditForm extends React.Component {
  static propTypes = {
    domNodes: PropTypes.shape({
      leaseMarketingVisibilityElement: PropTypes.object.isRequired,
      saleMarketingVisibilityElement: PropTypes.object.isRequired,
      settingsFormElement: PropTypes.object.isRequired
    }),
    leaseMarketingVisibilityProps: PropTypes.object.isRequired,
    saleMarketingVisibilityProps: PropTypes.object.isRequired,
    settings: PropTypes.shape({
      hideSyndication: PropTypes.bool,
      pushToConnect: PropTypes.bool,
      ...propertySettingsPropTypes
    }),
    onMarketingDisclaimer: PropTypes.shape(onMarketDisclaimerProps)
  }

  state = {
    settings: this.props.settings,
  }

  handleSyndicationChange = (syndication) => {
    this.setState(prevState => ({
      settings: { ...prevState.settings, syndication }
    }));
  }

  handlePushToConnectChange = (pushToConnect) => {
    const investmentTypeLabel = document.getElementById('investment-type-selector-label');
    if (pushToConnect) {
      investmentTypeLabel.classList.add('required');
    } else {
      investmentTypeLabel.classList.remove('required');
    }

    this.setState(prevState => ({
      settings: { ...prevState.settings, pushToConnect }
    }));
  }

  handleHideInternallyChange = (hideInternally) => {
    this.setState(prevState => ({
      settings: { ...prevState.settings, hideInternally }
    }));
  }

  render() {
    return (
      <React.Fragment>
        {this.renderSettingsForm()}
        {this.renderSaleMarketingVisibility()}
        {this.renderLeaseMarketingVisibility()}
        <OnMarketDisclaimer {...this.props.onMarketingDisclaimer}/>
      </React.Fragment>
    );
  }

  renderSettingsForm() {
    return ReactDOM.createPortal(
      <PropertySettings
        {...this.state.settings}
        onPushToConnectChange={this.handlePushToConnectChange}
        onSyndicationChange={this.handleSyndicationChange}
      />,
      this.props.domNodes.settingsFormElement
    );
  }

  renderSaleMarketingVisibility() {
    return ReactDOM.createPortal(
      <SaleMarketingVisibility
        closedListingPlugin={this.state.settings.closedListingPlugin}
        hideInternally={this.state.settings.hideInternally}
        hideSyndication={this.state.settings.hideSyndication}
        pushToConnect={this.state.settings.pushToConnect}
        showHideInternallyForStatuses={this.state.settings.showHideInternallyForStatuses}
        syndication={this.state.settings.syndication}
        syndicationDisconnectChannels={this.state.settings.syndicationDisconnectChannels}
        onHideInternallyChange={this.handleHideInternallyChange}
        onPushToConnectChange={this.handlePushToConnectChange}
        onSyndicationChange={this.handleSyndicationChange}
        {...this.props.saleMarketingVisibilityProps}
      />,
      this.props.domNodes.saleMarketingVisibilityElement
    );
  }

  renderLeaseMarketingVisibility() {
    return ReactDOM.createPortal(
      <LeaseMarketingVisibility
        hideInternally={this.state.settings.hideInternally}
        hideSyndication={this.state.settings.hideSyndication}
        showHideInternallyForStatuses={this.state.settings.showHideInternallyForStatuses}
        syndication={this.state.settings.syndication}
        syndicationDisconnectChannels={this.state.settings.syndicationDisconnectChannels}
        onHideInternallyChange={this.handleHideInternallyChange}
        onSyndicationChange={this.handleSyndicationChange}
        {...this.props.leaseMarketingVisibilityProps}
      />,
      this.props.domNodes.leaseMarketingVisibilityElement
    );
  }
}

export default class PropertyEditFormWrapper extends React.Component {
  static propTypes = {
    domIds: PropTypes.shape({
      leaseMarketingVisibility: PropTypes.string.isRequired,
      leaseSettingsForm: PropTypes.string.isRequired,
      saleMarketingVisibility: PropTypes.string.isRequired,
      settingsForm: PropTypes.string.isRequired
    })
  }

  domNodes = {
    leaseMarketingVisibilityElement: document.getElementById(this.props.domIds.leaseMarketingVisibility),
    settingsFormElement: document.getElementById(this.props.domIds.settingsForm),
    saleMarketingVisibilityElement: document.getElementById(this.props.domIds.saleMarketingVisibility)
  }

  render() {
    const { domIds, ...props } = this.props;
    return (
      <PropertyEditForm
        {...props}
        domNodes={this.domNodes}
      />
    );
  }
}
